export const regions = [
  "World",
  "Europe",
  "Africa",
  "Asia",
  "Americas",
  "Oceania",
];

export const countriesByRegion = {
  World: 197,
  Africa: 54,
  Asia: 48,
  Europe: 46,
  Oceania: 14,
  Americas: 35,
};

export const regionCodes = {
  World: "world",
  Africa: "002",
  "North Africa": "015",
  "West Africa": "011",
  "Central Africa": "017",
  "East Africa": "014",
  "Southern Africa": "018",
  Asia: "142",
  "Central Asia": "143",
  "East Asia": "030",
  "South Asia": "034",
  "South-East Asia": "035",
  "West Asia": "145",
  Europe: "150",
  "North Europe": "154",
  "West Europe": "155",
  "East Europe": "151",
  "South Europe": "039",
  Americas: "019",
  "North America": "021",
  "Caribbean America": "029",
  "Central America": "013",
  "South America": "005",
  Oceania: "009",
};

export const maxQuestionsByRegion = {
  World: { maps: 164, other: 197 },
  Africa: { maps: 49, other: 54 },
  Asia: { maps: 44, other: 48 },
  Europe: { maps: 38, other: 46 },
  Oceania: { maps: 6, other: 14 },
  Americas: { maps: 27, other: 35 },
};

export const listCategories = [
  "Countries",
  "Largest Populations",
  "Largest Areas",
  "Largest Densities",
  "Smallest Populations",
  "Smallest Areas",
  "Smallest Densities",
];

export const listGameConfig = (listCategory) => {
  return {
    World: {
      time: listCategory === "Countries" ? 1200 : 600,
      listLength:
        listCategory === "Countries" ? countriesByRegion["World"] : 30,
    },
    Asia: {
      time: listCategory === "Countries" ? 600 : 300,
      listLength: listCategory === "Countries" ? countriesByRegion["Asia"] : 15,
    },
    Africa: {
      time: listCategory === "Countries" ? 600 : 300,
      listLength:
        listCategory === "Countries" ? countriesByRegion["Africa"] : 15,
    },
    Europe: {
      time: listCategory === "Countries" ? 600 : 300,
      listLength:
        listCategory === "Countries" ? countriesByRegion["Europe"] : 15,
    },

    Americas: {
      time: listCategory === "Countries" ? 480 : 240,
      listLength:
        listCategory === "Countries" ? countriesByRegion["Americas"] : 10,
    },
    Oceania: {
      time: listCategory === "Countries" ? 300 : 120,
      listLength:
        listCategory === "Countries" ? countriesByRegion["Oceania"] : 5,
    },
  };
};

export const lookupCategories = [
  "Capital",
  "Region",
  "Population",
  "Area",
  "Density",
];
